import React from 'react'
import { Slider as SUISlider } from "react-semantic-ui-range";

const Slider = (props)=>{    
    return <SUISlider {...props}/>
}

export default Slider